import { usePreferences } from "../../../contexts/PreferencesContext";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { MdCheck, MdClose } from "react-icons/md";
import { useHistory } from "react-router-dom";

const ValidationModal = ({
  show,
  onClose,
  onValidate,
  id,
  isEditingContext
}) => {const { t } = usePreferences();
  const history = useHistory();

  const handleValidate = async () => {
    try {
      onValidate();
      // onClose();
    } catch (error) {
      console.error("Erro ao validar a questão:", error);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{t("ui_validar_questao_787fc7b5")}

        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ padding: "1.5rem", fontSize: "1rem", lineHeight: "1.5" }}>

        <p>{t("ui_essa_questao_foi_criada_por_ia_voce_deve_confirmar_74018da6")}


        </p>
        <p><b>{t("ui_voce_tem_certeza_que_deseja_validar_esta_questao_9e34f2f8")}</b> </p>
        <p>{t("ui_ao_confirmar_sera_redirecionado_para_a_pagina_de_b3319da3")}<b>{t("ui_criar_questao_beccec03")}</b>{t("ui_onde_podera_editar_seu_conteudo_como_desejar_10c9f36f")}</p>
        {/* {isEditingContext && (
            <div style={{ color: "red", fontWeight: "bold", marginTop: "1rem" }}>
              Certifique-se de definir o contexto da questão.
            </div>
           )} */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
        <MdClose />{` ${t("legacy_cancelar")}
        `}</Button>
        <Button
          variant="primary"
          onClick={handleValidate}>

          Validar <MdCheck />
        </Button>
      </Modal.Footer>
    </Modal>);

};

export default ValidationModal;